import React, {FC} from 'react';

import {Dialog} from '../../dialogs/dialog';
import {TagEditorBody, TagEditorBodyProps} from './tagEditorBody';

/*
 * Props.
 */

interface TagEditorDialogProps extends TagEditorBodyProps {}

/*
 * Component.
 */

export const TagEditorDialog: FC<TagEditorDialogProps> = (props) => (
  <Dialog onRequestClose={props.onRequestClose} width={300}>
    <TagEditorBody
      userId={props.userId}
      teammates={props.teammates}
      title={props.title}
      tagId={props.tagId}
      extraDropdownItems={props.extraDropdownItems}
      resourceNamespace={props.resourceNamespace}
      okButtonLabel={props.okButtonLabel}
      onOkClick={props.onOkClick}
      isEditing={props.isEditing}
      isSystemTag={props.isSystemTag}
      initialState={props.initialState}
      hasPermission={props.hasPermission}
      onRequestClose={props.onRequestClose}
      shouldHideNamespaceSelector={props.shouldHideNamespaceSelector}
      shouldHideParentTagSelector={props.shouldHideParentTagSelector}
      hasPreventPinTeamTags={props.hasPreventPinTeamTags}
      hasTagDescription={props.hasTagDescription}
      canCreateCompanyTags={props.canCreateCompanyTags}
      isSaving={props.isSaving}
      tagError={props.tagError}
    />
  </Dialog>
);
